import styles from './GamepadDevCard.module.css'
import { useTranslations } from 'next-intl'
import GamepadIcon from '@/assets/img/Icon_Gamepad.svg'
import { PhysicalPadUI } from '@/stores/usePadsStore'

interface GamepadDevCardProps {
  pad: PhysicalPadUI
}

export default function GamepadDevCard ({ pad }: GamepadDevCardProps) {
  const t = useTranslations('Modals.GamepadsManager.PhysicalPadDevCard')

  return (
    <div className={styles.gamepadDevCard}>
      <div className={styles.infoWrapper}>
        <GamepadIcon className={styles.icon} />
      </div>

      <div className={styles.contentWrapper}>
        <p className={`bodyTextLargeStrong`}>{t('deviceName', {id: pad.id})}</p>
      </div>
    </div>
  )
}